import { Textarea } from '@acpaas-ui/react-components';
import { useState } from 'react';
import SelectField from '../components/forms/SelectField';
import Modal from './Modal';
import ModalTitle from './ModalTitle';
import { DOSSIER_TYPES } from '../constants/dossier.constants';

const REASONS = {
  [DOSSIER_TYPES.PROGRAM]: [
    { value: 'other', label: 'Andere' },
    { value: 'completed', label: 'Traject afgerond' },
    { value: 'endedEarly', label: 'Vroegtijdig beëindigd' },
    { value: 'continued', label: 'Traject verdergezet' },
    { value: 'independent', label: 'Zelfstandig aan de slag' },
    { value: 'referred', label: 'Doorverwezen' }
  ],
  [DOSSIER_TYPES.FINANCED_PROGRAM]: [
    { value: 'other', label: 'Andere' },
    { value: 'completed', label: 'Traject afgerond' },
    { value: 'endedEarly', label: 'Vroegtijdig beëindigd' },
    { value: 'continued', label: 'Traject verdergezet' },
    { value: 'referred', label: 'Doorverwezen' }
  ],
  [DOSSIER_TYPES.ACTION]: [
    { value: 'completed_actie', label: 'Afgerond' },
    { value: 'endedEarly', label: 'Vroegtijdig beëindigd' },
    { value: 'continued_actie', label: 'Verdergezet in traject' },
    { value: 'referred', label: 'Doorverwezen' }
  ]
};

const StatusChangeModal = ({ dossierType, status, isOpen, onClose, onConfirm }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [remark, setRemark] = useState('');
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setIsSubmitting(false);
    setError('');
    setRemark('');
    setReason('');
    onClose();
  };

  const onApproveError = (error) => {
    setError(error);
    setIsSubmitting(false);
  };

  const onApproveSuccess = () => {
    setError('');
    setIsSubmitting(true);
    handleClose();
  };

  const handleConfirm = () => {
    setError('');
    setIsSubmitting(true);
    onConfirm(remark, reason, onApproveError, onApproveSuccess);
  };

  return (
    <Modal
      title={<ModalTitle title={`Status manueel wijzigen naar ${status?.label ?? ''}`} />}
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onClose={handleClose}
      onConfirm={handleConfirm}
      canConfirm={status?.label !== 'Afgesloten' || !!reason}
      onConfirmLabel="Bewaren"
      onConfirmIcon="ai-check-1"
      onConfirmType="success"
    >
      {status?.label === 'Afgesloten' && (
        <div className="row u-margin-bottom">
          <div className="col-xs-12">
            <SelectField
              disableSearch
              label="Reden"
              options={REASONS[dossierType]}
              value={reason}
              onChange={setReason}
              required
            />
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12">
          <Textarea
            label="Wat is de reden van deze status wijziging?"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </div>
      </div>
      {error && <small className="u-block u-margin-top-sm u-text-danger">{error}</small>}
    </Modal>
  );
};

export default StatusChangeModal;
